module.exports = __webpack_public_path__ + "static/media/intro.8369545e.mp3";